export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10717.2f8e9c2e.jpg";